<template>
  <div class="page">
    <div class="page-header flex justify-content-space-around align-items">
      <img :src="$path + pageDetail.icon" alt="" class="page-header-img" />
      <div class="page-header-info page-width flex-column justify-content-center">
        <div>
          <span class="page-chName">{{ pageDetail.name }}</span>
          <span class="page-esName">{{ pageDetail.enName }}</span>
        </div>
        <div class="page-bg-text">
          {{ pageDetail.description }}
        </div>
      </div>
    </div>
    <div class="container pageCont">
      <div class="row">
        <div class="col-lg-3 leftMenu text-center">
          <div class="leftMenu-title flex">
            <img
              src="@/assets/newsicon.png"
              alt=""
              style="width: 30px; height: 30px; margin-right: 5px"
            />
            <div class="flex-column text-left">
              <h3 style="font-size: 25px; color: #333333; margin-bottom: 0 !important">
                新闻中心
              </h3>
              <p style="font-size: 14px; color: #dbdbdb">NEWS CENTER</p>
            </div>
          </div>
          <div
            class="apiLeftMenu text-center"
            style="padding-top: 25px; padding-bottom: 25px; background: #f6f6f6"
          >
            <div
              class="apiLeftMenu-ever flex justify-content-space-around align-items"
              @click="menuChange(item)"
              v-for="(item, i) in menulist"
              :key="i"
              :style="changeStatus == item.id ? 'background:#FFFFFF;color:#0090FF;' : ''"
            >
              <span>{{ item.name }}</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
        <div class="col-lg-9 col-md-12 col-sm-12 col-12 rightCont">
          <!--头部-->
          <div class="rightCont-title">
            <span>当前位置：</span>
            <span class="page-click" @click="tohome">首页</span>
            <i class="el-icon-arrow-right"></i>
            <span class="page-click" @click="torefresh">新闻中心</span>
            <i class="el-icon-arrow-right" v-if="pageName != ''"></i>
            <span class="page-click">{{ pageName }}</span>
          </div>
          <div class="rightCont-menu-box">
            <div
              class="rightCont-menu flex align-items justify-content-space-between"
              @click="showMenu"
            >
              <div class="flex align-items">
                <img
                  src="@/assets/newsicon.png"
                  alt=""
                  style="width: 20px; height: 20px; margin-left: 15px"
                />
                <div style="font-size: 18px; color: #333333; margin-left: 5px">
                  新闻中心
                </div>
                <span
                  style="
                    color: #dbdbdb;
                    font-size: 14px;
                    margin-left: 10px;
                    padding-top: 5px;
                  "
                  >{{ pageDetail.enName }}</span
                >
              </div>
              <van-icon name="plus" color="#666666" style="margin-right: 15px" />
              <transition name="el-zoom-in-top">
                <div class="click-show" v-if="mobMenustatus">
                  <van-cell-group>
                    <van-cell
                      :title="item.name"
                      :style="changeStatus == item.id ? 'color:red;' : ''"
                      v-for="(item, i) in menulist"
                      @click="menuChange(item)"
                      :key="i"
                    >
                      <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                      <template #right-icon v-if="changeStatus == item.id">
                        <van-icon name="success" color="red" size="20px" />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </div>
              </transition>
            </div>
          </div>
          <!-- 详情 -->
          <div
            class="rightCont-html"
            v-html="detail.comment"
            v-if="changeStatus != '10303'"
          ></div>
          <div class="rightCont-html" v-if="changeStatus == '10303'">
            <video-player
              style="object-fit: fill"
              @ended="onPlayerEnded($event)"
              class="video-player vjs-custom-skin video-info"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
            ></video-player>
            <div v-html="detail.comment"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menulist: [],
      detail: {},
      changeStatus: "",
      pageName: "",
      clickStatus: 10086,
      mobMenustatus: false,
      pageDetail: {},
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "https://www.runoob.com/try/demo_source/movie.mp4", //url地址
          },
        ],
        poster: require("@/assets/videoImg.png"), //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  created() {
    if (window.localStorage.getItem("changeStatus") != null) {
      this.changeStatus = window.localStorage.getItem("changeStatus");
    }
    this.getleftMenu();
    this.getdetail();
    this.getPage();
  },
  methods: {
    getPage() {
      this.$api.iotHome
        .levelNavigation({
          columnId: "103",
        })
        .then((res) => {
          if (res.success) {
            this.pageDetail = res.data;
          }
        });
    },
    tohome() {
      this.$router.replace({
        path: "/",
      });
    },
    torefresh() {
      window.localStorage.removeItem("changeStatus");
      this.$router.push({
        path: "/news",
      });
    },
    getleftMenu() {
      this.$api.iotHome
        .newsNavigation({
          cmsColumnId: "103",
        })
        .then((res) => {
          if (res.success == true) {
            this.menulist = res.data;
            if (this.changeStatus == "") {
              this.changeStatus = this.menulist[0].id;
            }
            for (let i = 0; i < this.menulist.length; i++) {
              if (this.changeStatus == this.menulist[i].id) {
                this.pageName = this.menulist[i].name;
              }
            }
          }
        });
    },
    onPlayerEnded(e) {
      // console.log(this.$refs.videoPlayer.class);
      this.playerOptions = {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: this.playerOptions.sources[0].src, //url地址
          },
        ],
        poster: this.playerOptions.poster, //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      };
    },
    getdetail() {
      this.$api.iotHome
        .newsDetails({
          cmsArticleId: this.$route.query.id,
        })
        .then((res) => {
          if (res.success == true) {
            this.detail = res.data;
            this.detail.comment = this.detail.comment.replace(
              /src="(?![http])/g,
              'src="' + this.$paths
            );
            this.playerOptions.sources[0].src = this.$path + "/" + res.data.video;
            this.playerOptions.poster = this.$path + res.data.videoImage;
          }
        });
    },
    showMenu() {
      this.mobMenustatus = !this.mobMenustatus;
    },
    menuChange(data) {
      this.changeStatus = data.id;
      window.localStorage.setItem("changeStatus", data.id);
      this.$router.push({ path: "/news" });
    },
  },
};
</script>

<style>
@import url("../style/page.css");
</style>
<style scoped>
.rightCont-html /deep/ img {
  max-width: 100%;
  height: auto !important;
}

.rightCont-html /deep/ p {
  line-height: 35px !important;
}
.rightCont-html /deep/ table {
  max-width: 100%;
  width: auto;
  height: auto;
}
</style>
